import { atom } from 'recoil';

export const selectedAmount = atom({
  key: 'selectedAmount',
  default: undefined,
});
